const defaultOptions = {
  firstTimeStart: 0,

  timeBeforeDeleting: 2000,
  timeBeforeNext: 1000,

  cursorSpeed: 1000,
  cursorPause: 1000,

  animationTime: 2000,

  shuffle: false,
  loop: false,
  onLoopComplete: () => Promise.resolve(),
  writeByWord: false,
  textWrapperTag: "p",
  textSpanNodeID: "typed-text",
  cursorSpanNodeID: "typed-cursor",
  cursorSpanText: "|"
};

// Durstenfeld shuffle thanks to: http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

// Native javascript fadein (thanks to http://youmightnotneedjquery.com/)
function fadeIn(el) {
  el.style.opacity = 0;

  let last = +new Date();
  function tick() {
    el.style.opacity = +el.style.opacity + (new Date() - last) / 100;
    last = +new Date();
    if (+el.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
        setTimeout(tick, 16);
    }
  }

  tick();
}

// Native javascript fadeout (thanks to http://youmightnotneedjquery.com/)
function fadeOut(el) {
  el.style.opacity = 1;

  let last = +new Date();
  function tick() {
    el.style.opacity = +el.style.opacity - (new Date() - last) / 100;
    last = +new Date();
    if (+el.style.opacity > 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
        setTimeout(tick, 16);
    }
  }

  tick();
}

class TypedDirective {
  constructor(el, options = {}, vnode) {
    // The size of variable textItem
    this.substrCount = 0;
    // The item that is currenly typed
    this.textItem = "";
    // Extra time when ~ is used
    this.extraTime = 0;

    this.options = Object.assign({}, defaultOptions, options);
    this.reCalcAnimationTime();

    // Parent div
    this.parentDiv = el;
    this.parentNode = vnode;
  }

  start() {
    // Get all childrens of div (ie9+ browser compatibility)
    const divChildrens = Array.prototype.slice.call(this.parentDiv.childNodes);
    // Amount of children
    const childrenCount = divChildrens.length - 1;
    // Save only ELEMENT_NODES (P elements) (because 'var childrens' also saves TEXT_NODES)
    this.pElements = [];

    // Loop trough childrens of parent div
    divChildrens.forEach((item, i) => {
      // Only keep the ELEMENT_NODES (ELEMENT_NODE = P element = 1)
      if (item.nodeType === 1) {
        this.pElements.push(item.textContent);
      }

      // End of foreach
      if (childrenCount === i) {
        // We got our filtered result (only P elements)
        this.typeEffect();
      }
    });
  }

  stop() {
    clearTimeout(this.startTimer);
    clearInterval(this.cursorAnimationTimer);
  }

  reCalcAnimationTime() {
    if (this.isCalculated) return;
    this.isCalculated = true;

    let { timeBeforeDeleting, timeBeforeNext, animationTime } = this.options;
    this.options.animationTime =
      timeBeforeDeleting + timeBeforeNext + 1 + animationTime;
  }

  // Clean parent div
  emptyParentDiv() {
    while (this.parentDiv.firstChild) {
      this.parentDiv.removeChild(this.parentDiv.firstChild);
    }
  }

  // Let the cursor fadeout and fadein
  cursorAnimation() {
    const delay = this.options.cursorSpeed / 2;

    if (document.contains(this.cursorSpan)) fadeOut(this.cursorSpan);

    setTimeout(() => {
      if (document.contains(this.cursorSpan)) fadeIn(this.cursorSpan);
    }, delay);
  }

  writeLetter() {
    return new Promise(resolve => {
      if (this.textItem.substr(this.substrCount, 1) == "~") {
        this.textItem = this.textItem.replace("~", "");
        this.extraTime += this.options.cursorPause;
      }

      this.textSpan.innerHTML = this.textItem.substr(0, this.substrCount++);

      let timeNextLetter =
        (this.options.animationTime -
          this.options.timeBeforeDeleting -
          this.options.timeBeforeNext) /
        2 /
        this.textItem.length;

      if (this.substrCount < this.textItem.length + 1) {
        setTimeout(() => {
          resolve(false);
        }, timeNextLetter + this.extraTime);
        this.extraTime = 0;
      } else {
        return resolve(true);
      }
    });
  }

  writeWord() {
    return new Promise(resolve => {
      let words = this.textItem.split(" ").map(s => s.replace("~", "")),
        totalWords = words.length;

      this.textSpan.innerHTML = words.splice(0, this.substrCount++).join(" ");

      let timeNextLetter =
        (this.options.animationTime -
          this.options.timeBeforeDeleting -
          this.options.timeBeforeNext) /
        2 /
        totalWords;

      if (this.substrCount < totalWords + 1) {
        setTimeout(() => {
          resolve(false);
        }, timeNextLetter + this.extraTime);
        this.extraTime = 0;
      } else {
        return resolve(true);
      }
    });
  }

  // Native typing effect (each letter with a pause) thanks to: stathisg https://codepen.io/stathisg/pen/Bkvhg
  type(currentLoop) {
    return new Promise(async resolve => {
      try {
        let isWritten = false;
        if (this.options.writeByWord) {
          while (!isWritten) isWritten = await this.writeWord();
        } else {
          while (!isWritten) isWritten = await this.writeLetter();
        }

        if (
          this.options.whileLoopCount == this.pElementsCount &&
          !this.options.loop
        ) {
          resolve(currentLoop); // if there is no loop
        } else {
          setTimeout(() => {
            this.erase().then(() => resolve(currentLoop));
          }, this.options.timeBeforeDeleting);
        }
      } catch (e) {
        console.error("[typed] type() error", e);
      }
    });
  }

  removeLetter() {
    return new Promise(resolve => {
      this.textSpan.innerHTML = this.textItem.substr(0, this.substrCount--);
      let timeNextLetter =
        (this.options.animationTime -
          this.options.timeBeforeDeleting -
          this.options.timeBeforeNext) /
        2 /
        this.textItem.length;

      if (this.substrCount >= 0) {
        setTimeout(() => {
          resolve(false);
        }, timeNextLetter);
      } else {
        this.substrCount = 0;
        this.textItem = "";

        resolve(true);
      }
    });
  }

  removeWord() {
    return new Promise(resolve => {
      let words = this.textItem.split(" ").map(s => s.replace("~", "")),
        totalWords = words.length;

      this.textSpan.innerHTML = words.splice(0, this.substrCount--).join(" ");

      let timeNextLetter =
        (this.options.animationTime -
          this.options.timeBeforeDeleting -
          this.options.timeBeforeNext) /
        2 /
        totalWords;

      if (this.substrCount >= 0) {
        setTimeout(() => {
          resolve(false);
        }, timeNextLetter);
      } else {
        this.substrCount = 0;
        this.textItem = "";

        resolve(true);
      }
    });
  }

  // Native erasing effect (each letter with a pause) thanks to: stathisg https://codepen.io/stathisg/pen/Bkvhg
  async erase() {
    let isErased = false;
    if (this.options.writeByWord) {
      while (!isErased) isErased = await this.removeWord();
    } else {
      while (!isErased) isErased = await this.removeLetter();
    }

    return true;
  }

  typeEffect() {
    // Empty parent div (the P elements where only there for SEO friendliness)
    this.emptyParentDiv();

    // Add one P element
    let textWrapper = document.createElement(this.options.textWrapperTag);
    this.parentDiv.appendChild(textWrapper);

    // Add text SPAN element
    this.textSpan = document.createElement("span");
    this.textSpan.id = this.options.textSpanNodeID;

    this.parentDiv.firstChild.appendChild(this.textSpan);

    // Add cursor SPAN element
    this.cursorSpan = document.createElement("span");
    this.cursorSpan.id = this.options.cursorSpanNodeID;
    this.cursorSpan.innerHTML = this.options.cursorSpanText;

    this.parentDiv.firstChild.appendChild(this.cursorSpan);

    // Loop trough the old P elements
    this.pElementsCount = this.pElements.length - 1;

    let whileLoopCount = 0;
    // let makeAnimationLonger = 0;

    // shuffle array first (if shuffle = true)
    if (this.options.shuffle) {
      this.pElements = shuffleArray(this.pElements);
    }

    let self = this;

    function restartLoop() {
      // start all over (if loop = true)
      if (self.options.loop) {
        whileLoopCount = 0;
        loopElements();
      }
    }

    function loopElements() {
      if (whileLoopCount <= self.pElementsCount) {
        // Make the current typed item globally available (mainly for type() function)
        self.textItem = self.pElements[whileLoopCount];
        // Make time longer beacuse of ~
        // let countPauses = (self.textItem.match(/~/g) || []).length;
        // if (countPauses != 0) {
        //   makeAnimationLonger = countPauses * self.options.cursorPause;
        // } else {
        //   makeAnimationLonger = 0;
        // }

        self.type(whileLoopCount).then(() => {
          // It's like pausing the script, otherwise this loop is done in a few milisecond and you won't have an animation.
          setTimeout(loopElements, 10);
        });

        self.options.whileLoopCount = whileLoopCount++;
      } else {
        self.options.onLoopComplete(self.parentNode).then(restartLoop);
      }
    }

    // Force one loop (start)
    this.startTimer = setTimeout(loopElements, this.options.firstTimeStart);

    // Let the cursor blink (cursor span element)
    if (this.options.cursorSpeed) {
      this.cursorAnimation();
      this.cursorAnimationTimer = setInterval(() => {
        this.cursorAnimation();
      }, this.options.cursorSpeed);
    }
  }
}

const typed = {
  bind(el, binding, vnode) {
    const options = binding.value || {};

    const instance = new TypedDirective(el, options, vnode);
    instance.start();
    el._TypedInstance = instance;
  },

  unbind(el) {
    if (!el._TypedInstance) return;
    el._TypedInstance.stop();
    delete el._TypedInstance;
  }
};

export { typed };
export default typed;
